import { ShieldAlert, Home, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const NotAuthorized = () => {
    const navigate = useNavigate();

    return (
        <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-red-50 to-orange-50 px-4">
            <div className="w-full max-w-md text-center">
                {/* Icon */}
                <div className="mb-6 flex justify-center">
                    <div className="rounded-full bg-red-100 p-6">
                        <ShieldAlert className="h-16 w-16 text-red-600" />
                    </div>
                </div>

                {/* Title */}
                <h1 className="mb-4 text-4xl font-bold text-gray-900">
                    Acceso Denegado
                </h1>

                {/* Description */}
                <p className="mb-8 text-lg text-gray-600">
                    No tienes autorización para acceder a esta página.
                </p>

                {/* Details */}
                <div className="mb-8 rounded-lg bg-white p-6 shadow-sm">
                    <p className="text-sm text-gray-700">
                        Si crees que esto es un error, por favor contacta al administrador del sistema
                        o verifica tus permisos de acceso.
                    </p>
                </div>

                {/* Actions */}
                <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
                    <button
                        onClick={() => navigate(-1)}
                        className="inline-flex items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white px-6 py-3 text-sm font-semibold text-gray-700 shadow-sm transition hover:bg-gray-50"
                    >
                        <ArrowLeft className="h-4 w-4" />
                        Volver
                    </button>
                    <button
                        onClick={() => navigate("/")}
                        className="inline-flex items-center justify-center gap-2 rounded-lg bg-indigo-600 px-6 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-indigo-700"
                    >
                        <Home className="h-4 w-4" />
                        Ir al inicio
                    </button>
                </div>

                {/* Footer */}
                <p className="mt-8 text-xs text-gray-500">
                    Código de error: 403 - Forbidden
                </p>
            </div>
        </div>
    );
};

export default NotAuthorized;